export enum RoundingModes {
  // Rounding mode to round towards nearest value
  NEAREST,

  // Rounding mode to round towards zero.
  DOWN,

  // Rounding mode to round up to next whole value (with scale).
  UP,
}

/**
 * Round a number to the specified number of decimal places in the required direction.
 * All rounding is applied to the scaled value.
 *
 * @param value - The value to be rounded
 * @param method - The direction to round, one of (NEAREST or DOWN)
 * @param scale - The number of decimal places to round to
 */
export const round = (value: number, method: RoundingModes = RoundingModes.NEAREST, scale: number = 2): number => {
  switch (method) {
    case RoundingModes.NEAREST:
      return roundNearest(value, scale);
    case RoundingModes.DOWN:
      return roundDown(value, scale);
    case RoundingModes.UP:
      return roundUp(value, scale);
  }
};

const roundNearest = (value: number, scale: number = 0): number => {
  const p = Math.pow(10, scale);
  const n = value * p * (1 + Number.EPSILON);
  return Math.round(n) / p;
};

const roundDown = (value: number, scale: number): number => {
  const factor: number = 10 ** scale;
  return Math.floor(value * factor) / factor;
};

const roundUp = (value: number, scale: number): number => {
  const factor: number = 10 ** scale;
  return Math.ceil(value * factor) / factor;
};
